/** Formatting + input parsing helpers (spec §21 quality floor: currency inputs
 *  accept pasted values with dollar signs and commas). */

const usd0 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export function fmtUsd(n: number): string {
  if (!Number.isFinite(n)) return '—';
  return usd0.format(Math.round(n));
}

export function fmtCompactUsd(n: number): string {
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 999_500) return `${sign}$${(abs / 1_000_000).toFixed(2).replace(/\.?0+$/, '')}M`;
  if (abs >= 1_000) return `${sign}$${Math.round(abs / 1_000)}K`;
  return `${sign}$${Math.round(abs)}`;
}

export function fmtPct(n: number, digits = 1): string {
  if (!Number.isFinite(n)) return '—';
  return `${(n * 100).toFixed(digits)}%`;
}

/** Parse "$1,234,567.89", "1.2m", "450k", plain numbers. NaN when hopeless. */
export function parseCurrency(input: string): number {
  const s = input.trim().toLowerCase().replace(/[$,\s]/g, '');
  if (!s) return NaN;
  const suffix = s.endsWith('m') ? 1_000_000 : s.endsWith('k') ? 1_000 : 1;
  const num = parseFloat(suffix === 1 ? s : s.slice(0, -1));
  return Number.isFinite(num) ? num * suffix : NaN;
}
